<template>
  <template
    v-if="items.length > 0"
  >
    <report-card
      v-for="item in sortedReports"
      :key="item.id"
      :item="item"
    />
  </template>
  
  <p v-else>Geen meldingen gevonden</p>
</template>

<script>
import setRouteNameForModule from '@/helpers/route-name';
import { getAll } from '@/api/providers/reports';
import ReportCard from '@/components/Reports/Card.vue';

export default {
  components: {
    ReportCard,
  },

  data: () => ({
    items: [],
  }),

  computed: {
    sortedReports() {
      return Array.from(this.items).sort((a,b) => a.reportStatus > b.reportStatus || a.modifiedDate < b.modifiedDate)
    }
  },

  beforeMount() {
    setRouteNameForModule('Reports', 'Overzicht')
  },

  mounted() {
    this.loadReports();
  },

  methods: {
    async loadReports() {
      try {
        this.items = (await getAll()).reports ?? [];
      }
      catch {
        console.error("Lemon");
      }
    },
  },
};
</script>
